<template>
    <u-card-outlined-rounded v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-card-outlined-rounded>
</template>

<script>
import UCardOutlinedRounded from "@/components/publish/styles/cards/u-card-outlined-rounded.vue";

export default {
    props: {
    },
    components: {
        UCardOutlinedRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
